import { useApp } from "../context";
import { Badge } from "../components/Bits";
import {
  money, getCase, getPartner, collectionStatus, expected, entitlement, advance,
  received, paid, checks, pending
} from "../lib/engine";

export default function CaseDetail({ id }) {
  const { state, actions, closeModal, navigate } = useApp();
  const c = getCase(state, id);
  if (!c) return null;
  return (
    <div data-testid="case-detail-modal">
      <div className="muted">{c.id} · {c.disb}</div>
      <h2>{c.name}</h2>
      <p>{c.bank} · {getPartner(state, c).name}</p>
      <Badge text={collectionStatus(state, c)} testId="case-detail-status" />
      <div className="metric-grid">
        <div>Disbursement<b>{money(c.amount)}</b></div>
        <div>Expected commission<b data-testid="case-detail-expected">{money(expected(c))}</b></div>
        <div>DSA entitlement<b data-testid="case-detail-entitlement">{money(entitlement(c))}</b></div>
        <div>Proposed advance<b data-testid="case-detail-advance">{money(advance(c))}</b></div>
        <div>Bank receipts<b>{money(received(state, c))}</b></div>
        <div>DSA paid<b>{money(paid(state, c))}</b></div>
      </div>
      <p className="muted">
        Agreement {c.agreement} · Bank rate {c.bankRate}% · DSA rate {c.dsaRate}%<br />
        Lender reference {c.ref} · Due {c.due}
      </p>
      <h3>Advance controls</h3>
      <ul className="checks" data-testid="case-detail-checks">
        {checks(state, c, !!pending(state, c)).map(([name, ok]) => (
          <li key={name} className={ok ? "ok" : "no"}>{ok ? "✓" : "✕"} {name}</li>
        ))}
      </ul>
      <div className="footer">
        {!c.verified && (
          <button className="primary" data-testid="simulate-verification-btn" onClick={() => actions.verifyCase(c.id)}>
            Simulate verification
          </button>
        )}
        <button data-testid="open-payouts-btn" onClick={() => { closeModal(); navigate("Payout Approvals"); }}>
          Open payout approvals
        </button>
      </div>
    </div>
  );
}
